import type { SVGProps } from 'react';
const SvgBackwardSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 0H2C.897 0 0 .897 0 2v20c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm0 22H2V2h20v20c.003 0 0 0 0 0z" />
    <path d="M20.5 3h-17c-.275 0-.5.225-.5.5v17c0 .275.225.5.5.5h17c.275 0 .5-.225.5-.5v-17c0-.275-.225-.5-.5-.5zM20 20H4V4h16v16z" />
    <path d="m7.234 12.425 4 2.5a.503.503 0 0 0 .766-.426v-1.597l3.234 2.022a.503.503 0 0 0 .766-.426v-5a.5.5 0 0 0-.762-.426l-3.237 2.022V9.497a.5.5 0 0 0-.762-.426l-4 2.5c-.147.091-.234.253-.234.425s.084.331.231.425zM15 10.403V13.6L12.444 12 15 10.403zm-4 0V13.6L8.444 12 11 10.403z" />
  </svg>
);
export default SvgBackwardSquare;
